export const service = "vtz";
export const serviceDetail = {
  ocm: {
    service: "ocm",
    countryCode: "237",
    flag: "cm",
    lang: "fr",
  },
  vtz: {
    service: "vtz",
    countryCode: "255",
    flag: "tz",
    lang: "pr",
  },
};

export const isValidUrl = (str) => {
  try {
    new URL(str);
    return true;
  } catch {
    return false;
  }
};
